export default "__VITE_ASSET__C$TO30n6__"